var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "updateSchedule" },
    [
      _c(
        "VDialog",
        {
          attrs: { size: "large-plus" },
          model: {
            value: _vm.modelVisible,
            callback: function ($$v) {
              _vm.modelVisible = $$v
            },
            expression: "modelVisible",
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "div",
                {
                  staticClass: "pop-up__close",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/img/svg/close.svg"),
                      alt: "close",
                    },
                  }),
                ]
              ),
              _c("ErrorBanner", {
                staticClass: "add-prices-pop-up__info-banner",
                attrs: { errors: [_vm.translations.updateSchedulesIntro.text] },
              }),
              _vm._l(_vm.options, function (option, optionIndex) {
                return _c(
                  "div",
                  {
                    key: `option-${optionIndex}`,
                    staticClass: "updateSchedule__title",
                  },
                  [
                    optionIndex == _vm.currentPageIndex
                      ? _c(
                          "div",
                          [
                            _c("h1", { staticClass: "updateSchedule__title" }, [
                              _vm._v(_vm._s(_vm.getScheduleTitle()) + ":"),
                            ]),
                            _c(
                              "h3",
                              { staticClass: "updateSchedule__title2" },
                              [_vm._v('"' + _vm._s(option.name) + '"')]
                            ),
                            _vm._l(
                              option.schedules,
                              function (schedule, scheduleIndex) {
                                return _c(
                                  "div",
                                  {
                                    key: `schedule-${scheduleIndex}`,
                                    staticClass: "index-price-page__price",
                                  },
                                  _vm._l(
                                    schedule.price_schedules,
                                    function (
                                      priceSchedule,
                                      priceScheduleIndex
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: `priceSchedule-${priceScheduleIndex}`,
                                          on: {
                                            mouseleave: function ($event) {
                                              _vm.showEditMenu = null
                                            },
                                          },
                                        },
                                        [
                                          _vm.newScheduleType != null
                                            ? _c("EditPrices", {
                                                ref: _vm.getRef(
                                                  _vm.newScheduleType,
                                                  optionIndex,
                                                  scheduleIndex,
                                                  priceScheduleIndex
                                                ),
                                                refInFor: true,
                                                attrs: {
                                                  "is-active": true,
                                                  tour: _vm.tour,
                                                  "tour-lang": _vm.lang,
                                                  "tour-members":
                                                    schedule.price_schedules[
                                                      priceScheduleIndex
                                                    ].members,
                                                  "ticket-index": scheduleIndex,
                                                  "price-schedule":
                                                    schedule.price_schedules[
                                                      priceScheduleIndex
                                                    ],
                                                  "schedule-type":
                                                    _vm.newScheduleType,
                                                  translations:
                                                    _vm.pricesTranslate,
                                                  schedule: schedule,
                                                  editType: "times",
                                                  embedType: "schedule-update",
                                                },
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  0
                                )
                              }
                            ),
                          ],
                          2
                        )
                      : _vm._e(),
                  ]
                )
              }),
              _c(
                "div",
                { staticClass: "updateSchedule__buttons" },
                [
                  _vm.currentPageIndex === 0
                    ? _c("v-btn", {
                        attrs: {
                          outline: "",
                          name: _vm.translations.cancelBtn.text,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("close")
                          },
                        },
                      })
                    : _c("v-btn", {
                        attrs: {
                          outline: "",
                          name: _vm.translations.backBtn.text,
                        },
                        on: {
                          click: function ($event) {
                            _vm.currentPageIndex--
                          },
                        },
                      }),
                  _vm.currentPageIndex === _vm.options.length - 1
                    ? _c("v-btn", {
                        attrs: {
                          base: "",
                          name: _vm.translations.saveBtn.text,
                          enabled: true,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.save()
                          },
                        },
                      })
                    : _c("v-btn", {
                        attrs: {
                          base: "",
                          name: _vm.translations.nextBtn.text,
                          enabled: true,
                        },
                        on: {
                          click: function ($event) {
                            _vm.currentPageIndex++
                          },
                        },
                      }),
                ],
                1
              ),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "nav__pagination" },
                  _vm._l(_vm.options, function (option, optionIndex) {
                    return _c("div", { key: `pageNum${optionIndex}` }, [
                      _c("div", {
                        staticClass: "dot dot_page",
                        class: {
                          dot_page_active: optionIndex == _vm.currentPageIndex,
                        },
                      }),
                    ])
                  }),
                  0
                ),
              ]),
            ],
            2
          ),
        ]
      ),
      _c("hr"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }